import { Header } from "./Header"

export const Layout = ({ children, headerStyle }: { children: React.ReactNode; headerStyle?: string | null }) => {
  return (
    <div className="w-full relative">
      <Header style={headerStyle} />
      {children}
    </div>
  )
}
